/**
 * The name of the bundled sound file which will be played when new participant
 * joins the conference.
 */
export const PARTICIPANT_JOINED_FILE = 'knock.mp3';
/**
 * The name of the bundled sound file which will be played when any participant
 * leaves the conference.
 */
export const PARTICIPANT_LEFT_FILE = '';
